import { memo } from 'react';
import { useJsApi } from '../hooks/useJsApi';
function PublicCallingAPI() {
  useJsApi();
  return null;
}
export default /*#__PURE__*/memo(PublicCallingAPI);